import { render, staticRenderFns } from "./user-projects.vue?vue&type=template&id=689a4ff6&"
import script from "./user-projects.vue?vue&type=script&lang=js&"
export * from "./user-projects.vue?vue&type=script&lang=js&"
import style0 from "./user-projects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports